import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)`
  flex-grow: 1;
  font-size: ${({ theme }) => theme.typography.label.fontSize};
`;

export const Container = styled('span')`
  font-size: 14px;
`;
